import { MouseEventHandler } from 'react';

import { Text } from 'components/library';
import { ArrowLeft, Cross } from 'components/Icon';
import RoundButton from 'components/BackButton';

import * as S from './styled';

type ModalHeaderProps = {
    onClose: MouseEventHandler<HTMLButtonElement> & (() => void);
    onBack?: (MouseEventHandler<HTMLButtonElement> & (() => void)) | null;
    title: string;
};

const ModalHeader = ({ onClose, onBack, title }: ModalHeaderProps) => (
    <S.Container>
        {onBack && (
            <S.ReturnBack>
                <RoundButton
                    onClick={onBack}
                    data-testid="return-back"
                    badgeColor="text-main"
                    backgroundColor="surface-secondary"
                >
                    <ArrowLeft />
                </RoundButton>
            </S.ReturnBack>
        )}
        <Text center type="large-text">
            {title}
        </Text>
        <S.CloseButton>
            <RoundButton
                onClick={onClose}
                data-testid="close"
                badgeColor="text-main"
                backgroundColor="surface-secondary"
            >
                <Cross color="text-main" />
            </RoundButton>
        </S.CloseButton>
    </S.Container>
);

export default ModalHeader;
